<script lang="ts" setup>
import { useElementVisibility, watchOnce } from "@vueuse/core"

defineProps<{
	data?: {
		id: string
		title: string
		description: string
		image: {
			url: string
		}
	}[]
}>()

const { getImage } = useImage()
const config = useRuntimeConfig()
const target = useTemplateRef("section")
const targetIsVisible = useElementVisibility(target)
const isVisible = ref(false)

watchOnce(targetIsVisible, () => {
	isVisible.value = true
})

const image = getImage("/website/work-bg.svg", {
	modifiers: { height: 504 },
})

const style = computed(() => {
	if (targetIsVisible.value) {
		return {
			backgroundImage: `url(${image.url})`,
		}
	}

	return {}
})
</script>

<template>
	<section
		id="work"
		ref="section"
		:style="style"
		class="scroll-m-t-9xl bg-top py-12">
		<div class="mx-auto max-w-[1800px]">
			<LandingTitle class="mb-12 container">
				<template #title>
					چه کاری می کنه؟
				</template>

				<template #description>
					با اپلیکیشن بیشتر آشنا شو و ببین که چه کار هایی از دستش بر میاد !
				</template>
			</LandingTitle>

			<div
				class="flex justify-between gap-8 overflow-x-auto px-5 pb-5"
				data-aos="fade-up">
				<UsecaseCard
					v-for="item in data"
					:key="item.id"
					:description="item.description"
					:title="item.title"
					:image-url="`${config.public.strapi.address}${item.image.url}`" />
			</div>
		</div>
	</section>
</template>
